import store from 'store/storeConfig';

export const localizePreferredLanguage = (preferredLanguage?: string) => {
  const { intl } = store.getState();

  switch (preferredLanguage || '') {
    case 'en':
      return intl.messages['englishKey'];
    case 'fr':
      return intl.messages['frenchKey'];
    case 'es':
      return intl.messages['spanishKey'];
    case 'zh-Hans':
      return intl.messages['chineseSimplifiedKey'];
    case 'zh-Hant':
      return intl.messages['chineseTraditionalKey'];
    default:
      return '-';
  }
};

export const buildPatientLanguageOptions = () => {
  const { intl } = store.getState();
  const languages = intl.languages;
  return Object.entries(languages).map(([key, value]: any, i) => {
    return { label: value, value: key };
  });
};
